import React from "react";
import { useIntl } from "react-intl";
import NutritionDetails from "../nutrition-details/NutritionDetails";

const NutritionPanel = (props) => {
  const {
    container_contents,
    position,
    product_details,
    id,
    openedId,
    handleDestCollapsible,
    itemRef,
    isAtLeastOneNutrition,
    nahrwerte_string,
  } = props;
  const intl = useIntl();
  const additionalFields = product_details?.fields || [];

  const hasNonZeroNutrition = () => {
    if (!product_details) {
      return false;
    }

    const nutritionKeys = [
      "fat",
      "saturates",
      "carbohydrate",
      "sugars",
      "protein",
      "salt",
    ];

    const result = nutritionKeys.some((key) => {
      const rawValue = product_details[key];
      const numericVal = parseFloat(rawValue);
      return numericVal > 0;
    });

    return result;
  };

  const showNutritionalPanel = product_details && hasNonZeroNutrition();

  const getDetailsConfig = () => {
    if (!product_details) return [];

    const config = [];

    additionalFields.forEach((field) => {
      config.push({
        detailType: field.name,
        label: field.name,
        content: field.value,
        separator: true,
      });
    });

    return config;
  };
  const detailsConfig = getDetailsConfig();

  return (
    <>
      {container_contents && (
        <NutritionDetails
          detailType="inhalt"
          label={intl.formatMessage({ id: "ingredients" })}
          position={position}
          product_details={{ inhalt: container_contents }}
          id={id}
          openedId={openedId}
          handleDestCollapsible={handleDestCollapsible}
          showNutritionDetailsField={false}
          ref={itemRef}
        />
      )}
      {product_details &&
        detailsConfig.map((config) => (
          <NutritionDetails
            key={config.detailType}
            detailType={config.detailType}
            label={config.label}
            position={position}
            product_details={product_details}
            id={id}
            openedId={openedId}
            handleDestCollapsible={handleDestCollapsible}
            ref={itemRef}
            separator={config.separator ? config.separator : undefined}
            content={config.content}
          />
        ))}
      {showNutritionalPanel && (
        <NutritionDetails
          detailType="nutritional_values"
          label={nahrwerte_string}
          position={position}
          product_details={product_details}
          id={id}
          openedId={openedId}
          handleDestCollapsible={handleDestCollapsible}
          showNutritionDetailsField={true}
          ref={itemRef}
        />
      )}
    </>
  );
};

export default NutritionPanel;
